<header class="header">
	<div class="header__wrapper">
		<div class="title">
			<h1 class="title__headline">{{ 'TITLE' | translate }}</h1>
		</div>
		<div class="logo">
			<img src="assets/images/logo.svg" alt="Hess" class="logo__image" />
		</div>
	</div>
</header>
<div class="subtitlebar">
	<h2 class="subtitlebar__title">{{ 'SYNC.TITLE' | translate }}</h2>
</div>
<div class="sync">
	<div class="sync__container">
		<div class="syncing" *ngIf="status == 'sync'">
			<div class="syncing__wrapper">
				<div class="syncing__spinner"></div>
				<i class="fa fa-sync syncing__icon syncing__icon--sync"></i>
			</div>
			<div class="syncing__text">{{ text | translate }}</div>
		</div>
		<div class="syncing" *ngIf="status == 'success'">
			<div class="syncing__wrapper" (tap)="onBackToStage()">
				<div class="syncing__spinner syncing__spinner--success"></div>
				<i class="fa fa-check syncing__icon syncing__icon--success"></i>
			</div>
			<div class="syncing__text syncing__text--success">{{ text | translate }}</div>
		</div>
		<div class="syncing" *ngIf="status == 'error'">
			<div class="syncing__wrapper">
				<div class="syncing__spinner syncing__spinner--error"></div>
				<i class="fa fa-times syncing__icon syncing__icon--error"></i>
			</div>
			<div class="syncing__text syncing__text--error">{{ text | translate }}</div>
		</div>
		<div class="progress-bar">
			<div class="progress-bar__inner" [ngStyle]="getStyle()"></div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/sync/sync.component.html